import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center overflow-hidden"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/8e81fcdae433283a4f5b08c7afe4b7b9.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center 45%',
      }}
    >
      {/* Cinematic overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/97 via-[#0A0A0A]/82 to-[#0A0A0A]/25" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/55 via-transparent to-[#0A0A0A]/75" />

      {/* Gold vertical line */}
      <div className="absolute left-0 top-0 h-full w-0.5 bg-gradient-to-b from-transparent via-[#C9A030]/45 to-transparent hidden lg:block" />

      {/* Breadcrumb */}
      <div className="absolute top-0 left-0 w-full pt-24 px-6 lg:px-14 z-10">
        <p className="text-[#C9A030] text-[10px] tracking-[0.4em] uppercase font-semibold flex items-center gap-3">
          <Link to="/" className="hover:text-[#D4B045] cursor-pointer transition-colors">Home</Link>
          <span className="text-[#F2EDE3]/20">/</span>
          <span className="text-[#F2EDE3]/50">About ECS</span>
        </p>
      </div>

      {/* Main content */}
      <div className="relative z-10 w-full px-6 lg:px-14 pb-20">
        <div className="max-w-[680px]">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-10 h-px bg-[#C9A030]" />
            <p className="text-[#C9A030] text-[10px] tracking-[0.45em] uppercase font-semibold">
              Energy Contractor Services
            </p>
          </div>

          <h1 className="font-serif leading-[1.05] tracking-tight mb-8">
            <span className="block text-[46px] lg:text-[72px] font-light text-[#F2EDE3]">
              The Compliance Specialists
            </span>
            <span className="block text-[46px] lg:text-[72px] font-light text-[#F2EDE3]">
              Energy Contractors
            </span>
            <span className="block text-[46px] lg:text-[72px] font-light text-[#C9A030] italic">
              Rely On.
            </span>
          </h1>

          <p className="text-[#F2EDE3]/50 text-lg font-light leading-relaxed mb-9 max-w-[520px]">
            Energy Contractor Services exists for one purpose: ensuring energy contractors are 100% compliant on every platform — with guaranteed results, dedicated personal service, and zero long-term contracts.
          </p>

          <div className="flex flex-wrap gap-3 mb-12">
            <Link
              to="/contact"
              className="bg-[#C9A030] text-[#0A0A0A] px-8 py-4 text-[11px] font-bold tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-[#D4B045]"
            >
              Work With ECS
            </Link>
            <a
              href="tel:4054081117"
              className="inline-flex items-center gap-2 border border-[#F2EDE3]/22 text-[#F2EDE3]/70 px-8 py-4 text-[11px] font-medium tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:border-[#C9A030]/60 hover:text-[#C9A030]"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-xs" />
              </span>
              405-408-1117
            </a>
          </div>

          {/* Trust pillars */}
          <div className="flex flex-wrap items-center gap-6">
            {[
              { icon: 'ri-shield-check-fill', text: 'ISNetworld® Experts' },
              { icon: 'ri-user-star-line', text: 'Same Expert Always' },
              { icon: 'ri-calendar-check-line', text: 'No Contracts' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-[#C9A030] text-sm`} />
                </div>
                <span className="text-[#F2EDE3]/45 text-[11px] tracking-[0.18em] uppercase font-light whitespace-nowrap">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-14 hidden lg:flex flex-col items-center gap-3 text-[#F2EDE3]/20">
        <div className="w-px h-14 bg-gradient-to-b from-[#C9A030]/50 to-transparent" />
        <span className="text-[9px] tracking-[0.4em] uppercase font-light">Scroll</span>
      </div>
    </section>
  );
}
